var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.rates != -1)?_c('span',[_vm._v(" "+_vm._s(_vm.rates)+" ")]):_c('span',[_c('i',{staticClass:"el-icon-loading",staticStyle:{"font-size":"16px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.liveRates))])])])}
var staticRenderFns = []

export { render, staticRenderFns }